import React, { useState, useEffect, useRef } from "react";
import { images } from "../../config/images";
import {
    Grid,
    Container,
    Typography,
    Table,
    TableBody,
    TableRow,
    TableCell,
    TablePagination,
    TableHead,
    Modal,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

import { Button } from "../../components/Button/button";

const DispatchPrintPreview = () => {
    const navigate = useNavigate();
    return (
        <>
            <div className="containerWrap">
                <Container maxWidth="xxl">
                    <div className="packingHeader-wrap">
                        <div className="packingTitle-wrap">
                            <KeyboardBackspaceIcon
                                onClick={() => navigate("/dispatch-summary")}
                                className="backArrow"
                            />
                            <Typography
                                variant="h5"
                                className="packingTitle"
                                gutterBottom
                                onClick={() => navigate("/dispatch-summary")}
                            >
                                Dispatch Print Preview
                            </Typography>
                        </div>
                        <div className="dispatchSummary-print-section">
                            <img src={images.printIcon} />
                            <Button
                                title="print history"
                                classname={"border-btn"}
                                onClick={() => navigate("/dispatch-print-history")}
                                style={{
                                    width: "120px", backgroundColor: "white",
                                    border: "1px solid #475467",
                                    color: "#3C4856"
                                }}
                            />
                        </div>
                    </div>


                    <div className="dispatch-history-container">
                        <div className="dispatch-history-header">
                            <img
                                src={images.previewQrCode} // Replace with QR code or dynamic URL
                                alt="QR Code"
                                className="qr-code"
                            />
                            <div className="company-info">
                                <img src={images.logo} alt="Astral Pipes Logo"></img>

                            </div>
                        </div>
                        <div className="dispatch-history-table">
                            <Table sx={{
                                border: "2px solid black",
                                "& td, & th": { border: "2px solid black", padding: "10px" },
                            }}>
                                <TableBody className="dispatch-history-tableBody">
                                    <TableRow className="dispatch-history-tableBodyRow">
                                        <TableCell
                                            className="dispatch-history-tableBodyCell"
                                        >
                                            <b style={{ fontSize: "18px" }}>Customer Name:</b>
                                        </TableCell>
                                        <TableCell className="dispatch-history-tableBodyCell"
                                            colSpan={2}
                                        >
                                            Relaiance Project @ Property Management Services Limited
                                        </TableCell>
                                    </TableRow>
                                    <TableRow className="dispatch-history-tableBodyRow">
                                        <TableCell className="dispatch-history-tableBodyCell"
                                            colSpan={2}
                                        >
                                            <b style={{ fontSize: "18px" }}>Product Description:</b>
                                        </TableCell>
                                        <TableCell
                                            className="dispatch-history-tableBodyCell"
                                            align="center"
                                        >
                                            <b style={{ fontSize: "18px" }}>Qty</b>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow className="dispatch-history-tableBodyRow" rowspan={2}>
                                        <TableCell
                                            className="dispatch-history-tableBodyCell"
                                            colSpan={2}
                                        >
                                            (N.B. 20MM. 3/4") (0022.2MM) ASTM D2846 CPVC <br />
                                            (N.B. 20MM. 3/4") (0022.2MM) ASTM D2846 CPVC
                                        </TableCell>
                                        <TableCell
                                            className="dispatch-history-tableBodyCell"
                                            align="center"
                                        >
                                            947 <br />
                                            94
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </div>
                    </div>
                </Container>
            </div>
        </>
    )
}
export default DispatchPrintPreview;
